import React, { useState, useContext } from 'react'

/* package */
import { GlobalContext } from '../../lib-atomic-context'
import { SectionWrappSingle } from '../../lib-atomic-section'
/* package */

/* container */
import Container from '../../app-content-container/default'
/* container */

/* form */
import Content from '../layout/content'
import Expandable from '../layout/expandable'
/* form */

const Index = (props) => {
  const { cognitouser, contentdetail, contentcarouseldetail } = useContext(
    GlobalContext
  )
  const [isNotCarousel, setIsNotCarousel] = useState(true)
  const [detailVisible, setDetailVisible] = useState(false)
  const toggleDetailVisibility = () => {
    setDetailVisible(!detailVisible)
  }
  return (
    <Container.ContentDetailNotification {...props}>
      <SectionWrappSingle
        {...{
          ...props,
          maxWidth: isNotCarousel ? (detailVisible ? 'lg' : 'sm') : 'sm',
        }}
      >
        <Content
          {...{
            ...props,
            user: cognitouser.state.data,
            item: contentdetail.state.data,
            isNotCarousel,
            setIsNotCarousel,
            detailVisible,
            toggleDetailVisibility,
          }}
        />
        <Expandable {...props} />
      </SectionWrappSingle>
    </Container.ContentDetailNotification>
  )
}

export default Index
